// extracted by mini-css-extract-plugin
export default {"headLine":"index_headLine_W5avL","inner":"index_inner_C1B51","pl24":"index_pl24_hYmqs","cRed2":"index_cRed2_kOCjr","num":"index_num_ffrwS"};